if (!customElements.get("multicolumn-show-more")) {
  customElements.define(
    "multicolumn-show-more",
    class MulticolumnShowMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector("button");
        this.container = this.closest(".multicolumn");
        this.list =
          this.container && this.container.querySelector(".multicolumn-list");
        if (!this.button || !this.container || !this.list) return;

        const prefersReduced = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        );
        this.duration = prefersReduced.matches ? 0 : 400;
        prefersReduced.addEventListener?.("change", (e) => {
          this.duration = e.matches ? 0 : 400;
        });

        this.isAnimating = false;
        this.button.addEventListener("click", () => this.toggle());
      }

      toggle() {
        if (this.isAnimating) return;
        const isExpanded =
          this.container.getAttribute("data-expanded") === "true";
        this.button.setAttribute("aria-expanded", String(!isExpanded));
        if (isExpanded) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      expand() {
        const list = this.list;
        const startHeight = list.offsetHeight;
        this.container.setAttribute("data-expanded", "true");
        const endHeight = list.scrollHeight;
        this.runAnimation(startHeight, endHeight, "true");
      }

      collapse() {
        const list = this.list;
        const startHeight = list.offsetHeight;
        // Measure the collapsed target without painting.
        this.container.setAttribute("data-expanded", "false");
        const endHeight = list.scrollHeight;
        // Restore expanded so items stay visible while the container animates down.
        this.container.setAttribute("data-expanded", "true");
        void list.offsetHeight;
        this.runAnimation(startHeight, endHeight, "false");
      }

      runAnimation(startHeight, endHeight, finalState) {
        const list = this.list;

        if (this.duration === 0 || startHeight === endHeight) {
          this.container.setAttribute("data-expanded", finalState);
          return;
        }

        this.isAnimating = true;
        list.style.height = startHeight + "px";
        list.style.overflow = "hidden";
        void list.offsetHeight;
        list.style.transition =
          "height " + this.duration + "ms cubic-bezier(0.4, 0, 0.2, 1)";
        list.style.height = endHeight + "px";

        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          list.removeEventListener("transitionend", onEnd);
          this.container.setAttribute("data-expanded", finalState);
          list.style.transition = "";
          list.style.height = "";
          list.style.overflow = "";
          this.isAnimating = false;
        };
        const onEnd = (e) => {
          if (e.target !== list || e.propertyName !== "height") return;
          finish();
        };
        list.addEventListener("transitionend", onEnd);
        // Safety net in case transitionend never fires (tab hidden, etc).
        setTimeout(finish, this.duration + 100);
      }
    },
  );
}
